import { Option, Options } from '../models/utils';
import { ValueType } from 'react-select';
import { join, propOr } from 'ramda';

export function valueToArray(value: ValueType<Option>): Options {
  if (value === null || value === undefined) {
    return [];
  }
  if (isReadonlyArray<Option>(value)) {
    return [...value];
  }
  return [value];
}

export function isReadonlyArray<T>(u: unknown): u is readonly T[] {
  return Array.isArray(u);
}

export function createTokenizer<T extends string>(...props: T[]) {
  return function idGenerator(obj: Record<T, string | undefined | null>) {
    return join(':', props.map(prop => propOr('', prop, obj)));
  };
}
